export default "__VITE_ASSET__DTnn6hdO__"